let cartUpdated = false;

const init = () => {
  $('.quantity input[type="number"]').each(function() {
    const $el = $(this);
    const $wrap = '<div class="custom-number-input"></div>';
    // Wrap element in a container
    const $wrappedEl = $el.wrap($wrap);
    const $wrappedElParent = $wrappedEl.parent();
    $wrappedElParent.append('<div class="custom-number-input__spinner"><button type="button" class="up button">&rsaquo;</button><button type="button" class="down button">&lsaquo;</button></div>');
    const $buttonUp = $wrappedElParent.find('button.up');
    const $buttonDown = $wrappedElParent.find('button.down');


    $buttonUp.on('click', function() {
      let value = parseInt($el.val());
      value++;
      $el.val(value).trigger('change');
    });

    $buttonDown.on('click', function() {
      let value = parseInt($el.val());
      if(value !== 0) {
        value--;
        $el.val(value).trigger('change');
      }
    });
  });
  if(!cartUpdated) {
    bindUpdateCartEvent();
  }

}

const bindUpdateCartEvent = ()=> {
  $(document.body).on('updated_cart_totals', function() {
    cartUpdated = true;
    init();
  });
}

export default init;



// WEBPACK FOOTER //
// ./scripts/components/custom-number-input.js